import { UI } from "../constants/tokens";
import { itemLabel } from "../constants/secItems";
import { Bidi } from "./MarketTodayCard";
import LTR from "./LTR";

// ─── One report to the SEC, as the company filed it (sprint 21) ────────────
// The form and day, what the main item is, "מה דווח" (the checked summary,
// every sentence ending with its document), and the links to the report and
// its press release. Shared by the article window and the stock panel.

const ddmmyy = d => new Date(`${d}T16:00:00Z`).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit", timeZone: "America/New_York" });
const LINK = { color: UI.interactive, textDecoration: "none", fontWeight: 600 };

const WHY_NONE = {
  // Also when the model failed three times: nothing that passed was made.
  failed: "לא נוצר סיכום שעבר את הבדיקות",
  skipped: "לא נמצא בדיווח טקסט לסכם",
  pending: "הסיכום עוד לא מוכן",
};
const SEC = /^https:\/\/www\.sec\.gov\//;

export default function FilingSummary({ filing: f, compact = false }) {
  if (!f) return null;
  const linked = SEC.test(f.doc_url || "") || SEC.test(f.press_url || "");
  return (
    <div data-filing={f.accession} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <span style={{ fontSize: 12.5, color: UI.text.muted }}>
        <LTR>{f.form}</LTR> · <LTR className="si-num">{ddmmyy(f.filed_date)}</LTR> · {itemLabel(f.form, f.main_item)}
      </span>
      {Array.isArray(f.summary) && f.summary.length > 0 && f.summary_status !== "failed" ? (
        <div style={{ fontSize: compact ? 14 : 15, color: UI.text.primary, lineHeight: 1.75 }}>
          {f.summary.map((l, i) => <span key={i}>{i ? " " : ""}<Bidi text={l.text}/></span>)}
        </div>
      ) : (
        // A report with no summary (the stock panel lists every one): why.
        <span style={{ fontSize: 13, color: UI.text.secondary }}>
          {WHY_NONE[f.summary_status] || WHY_NONE.pending}{linked ? " · הדיווח המלא בקישור" : ""}
        </span>
      )}
      <span style={{ fontSize: 12.5, display: "flex", gap: 14, flexWrap: "wrap" }}>
        {SEC.test(f.doc_url || "") && (
          <a href={f.doc_url} target="_blank" rel="noopener noreferrer" style={LINK}>הדיווח ב-<LTR>SEC</LTR></a>
        )}
        {SEC.test(f.press_url || "") && (
          <a href={f.press_url} target="_blank" rel="noopener noreferrer" style={LINK}>ההודעה לעיתונות</a>
        )}
      </span>
    </div>
  );
}
